<nz-table
  class="ui-table-wrapper"
  nzShowSizeChanger
  [nzData]="tableData"
  [nzLoading]="loading"
  [nzTotal]="total"
  (nzQueryParams)="onQueryParamsChange($event)"
  [nzPageSize]="pageSize"
  [nzPageIndex]="pageIndex"
  [nzFrontPagination]="isFrontPagination"
  [nzShowPagination]="showPagination"
  [nzPageSizeOptions]="pageSizeOptions"
  [nzShowTotal]="totalTemplateRef"
  [nzHideOnSinglePage]="false"
  [nzLoadingIndicator]="loadingIndicatorRef"
  [nzScroll]="{ y: scrollHeight }"
  [ngClass]="{ 'paginated-table': showPagination }"
>
  <thead>
    <tr>
      @if(isRowSelectionTable){
      <th
        class="ui-table-checkbox"
        [nzChecked]="checked"
        [nzDisabled]="rowSelectionDisabled"
        [nzIndeterminate]="indeterminate"
        (nzCheckedChange)="onAllChecked($event)"
        nzWidth="50px"
      ></th>
      } @for (column of tableColumns; track $index) {
      <th
        [nzShowSort]="column.sortable"
        [nzSortFn]="!!column.sortable"
        [nzWidth]="column?.width ?? null"
      >
        <ui-table-header-column [config]="column"></ui-table-header-column>
      </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (rowData of tableData; track trackBy(rowData, index); let index=$index) {
    <tr [ngClass]="{ odd: index % 2 !== 0 }">
      @if(isRowSelectionTable){
      <td
        class="ui-table-checkbox"
        [nzChecked]="setOfCheckedId.has(rowData | getFieldValue : rowSelectionByField)"
        [nzDisabled]="rowSelectionDisabled"
        (nzCheckedChange)="onItemChecked(rowData, $event)"
      ></td>

      } @for (column of tableColumns; track $index) {
      <td>
        <ui-table-body-column
          [index]="index + pageSize * (pageIndex - 1)"
          [config]="column"
          [data]="rowData"
          (updateTableData)="onUpdateTableData()"
          (rowClicked)="onRowClicked($event, rowData)"
        ></ui-table-body-column>
      </td>
      }
    </tr>
    }
  </tbody>
</nz-table>

<ng-template #loadingIndicatorRef>
  <div class="loading-indicator-wrapper">
    <ui-loading [text]="'Загрузка данных...'"></ui-loading>
  </div>
</ng-template>

<ng-template #totalTemplateRef let-total>
  <b>
    {{ ('SHARED_TABLE_TOTAL' | localization) + total }}
  </b>
</ng-template>
